module.exports = __webpack_public_path__ + "static/media/heart-empty-pink-outline.f7b3bbe4.svg";